export const UBA_EVENT_NAMES = {
  log: "di_log",
  errorLog: "di_errorLog",
  joinAsView: "di_joinAsView",
  joinAsActionClick: "di_joinAsActionClick",
  joinAsCandidateView: "di_joinAsCandidateView",
  joinAsCandidateActionClick: "di_joinAsCandidateActionClick",
  otpView: "di_otpView",
  otpActionClick: "di_otpActionClick",
  lobbyView: "di_lobbyView",
  lobbyActionClick: "di_lobbyActionClick",
  selectQuestionTypeView: "di_selectQuestionTypeView",
  candidateWaitView: "di_candidateWaitView",
  selectQuestionTypeActionClick: "di_selectQuestionTypeActionClick",
  libraryView: "di_libraryView",
  libraryQuestionAddClick: "di_libraryQuestionAddClick",
  libraryTabClick: "di_libraryTabClick",
  reloadStubClick: "di_reloadStubClick",
  runCodeClick: "di_runCodeClick",
  technologySelectClick: "di_technologySelectClick",
  tecnologySelectItemClick: "di_technologySelectItemClick",
  codingView: "di_codingView",
  whiteboardView: "di_whiteboardView",
  questionTabCloseClick: "di_questionTabCloseClick",
  questionTabAddClick: "di_questionTabAddClick",
  createQuestionClick: "di_createQuestionClick",
  importQuestionClick: "di_importQuestionClick",
  endInterviewClick: "di_endInterviewClick",
  settingsClick: "di_settingsClick",
  createQuestionModalView: "di_createQuestionModalView",
  createQuestionModalActionClick: "di_createQuestionModalActionClick",
  interviewFeedbackView: "di_interviewFeedbackView",
  interviewFeedbackActionClick: "di_interviewFeedbackActionClick",
  doSelectPlatformFeedbackView: "di_doSelectPlatformFeedbackView",
  doSelectPlatformFeedbackSubmitClick: "di_doSelectPlatformFeedbackSubmitClick",
  confirmModalView: "di_modalView",
  modalView: "di_modalView",
  modalActionClick: "di_modalActionClick",
  notificationPopupView: "di_notificationPopupView",
  notificationPopupActionClick: "di_notificationPopupActionClick",
};

export const PAGE_NAME = {
  joinAs: "joinAs",
  joinAsCandidate: "joinAsCandidate",
  opt: "opt",
  lobby: "lobby",
  selectQuestionType: "selectQuestionType",
  candidateWait: "candidateWait",
  library: "library",
  coding: "coding",
  whiteboard: "whiteboard",
  interviewFeedback: "interviewFeedback",
  doSelectPlatformFeedback: "doSelectPlatformFeedback",
  confirmModal: "confirmModal",
  notificationPopup: "notificationPopup",
  mediaDevicePermissionAlertModal: "mediaDevicePermissionAlertModal",
  realtimeAlertModal: "realtimeAlertModal",
};

export const SERVICE_NAME = "do-candidate-interface";
